module.exports = __webpack_public_path__ + "static/media/express-seeklogo.com.29b244c3.svg";